import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffectiveAccess } from '../../agenticsaas/contexts/EffectiveAccessContext';
import { resolveNavIdForPath } from '../../config/navAccessMap';
import AccessDenied from './AccessDenied';

/**
 * Waits for RBAC payload, then enforces route-level module access (not just sidebar).
 */
export default function AccessGuard({ children }) {
  const { loading, canAccessNavItem } = useEffectiveAccess();
  const location = useLocation();
  const navId = resolveNavIdForPath(location.pathname, location.search);

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center py-24">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (navId && !canAccessNavItem(navId)) {
    return <AccessDenied navId={navId} />;
  }

  return children;
}
